/** GDPR data export configuration constants */
/** How long (in hours) the download link remains valid */
export const GDPR_EXPORT_LINK_EXPIRY_HOURS = 48;
/** Minimum delay (in hours) between two export requests from the same user */
export const GDPR_EXPORT_COOLDOWN_HOURS = 24;
/** Possible statuses of an export request */
export const GDPR_EXPORT_STATUSES = ['pending', 'processing', 'completed', 'failed'];
/** Storage bucket name for GDPR exports */
export const GDPR_EXPORTS_BUCKET = 'gdpr-exports';
//# sourceMappingURL=gdpr-export.js.map